import React from 'react'
import ScrolltoTop from '../components/ScrollToTop'
import SignIn from '../components/Signin'

const SigninPage = () => {
  return (
    <>
      <ScrolltoTop />
      <SignIn />
    </>
  )
}

export default SigninPage
